import errorManager from '@/rollbar.js';
const initRoomBedsResult = (item) => {
  if (item.loading) return item.text;

  const [unit, room, bed, pax, rt] = item.text.split(' - ');
  const typeNames = ['unit', 'room', 'bed'];
  let p = document.createElement('p');
  let i = 0;
  for (let part of [unit, room, bed]) {
    const [elIcon, elName] = appendEl(part || '', typeNames[i]);
    p.appendChild(elIcon);
    p.appendChild(elName);
    i += 1;
  }
  if (pax && pax != '-') {
    const paxI = parseInt(pax);
    for (let i = 0; i < paxI; i++) {
      let nodeIcon = document.createElement('span');
      nodeIcon.className = 'fa fa-user';
      p.appendChild(nodeIcon);
    }
  }
  if (rt && rt != '-') {
    let nodeRt = document.createElement('span');
    nodeRt.setAttribute('style', 'margin-left: 1em;');
    nodeRt.innerText = '(' + rt + ')';
    p.appendChild(nodeRt);
  }
  return $(p);
};
const roomBedsResult = (item) => {
  try {
    return initRoomBedsResult(item);
  } catch (e) {
    errorManager(e);
  }
};

const appendEl = (el, type) => {
  let nodeIcon = document.createElement('span');
  nodeIcon.className = 'fa ' + cssFaClass(type);
  let node = document.createElement('span');
  node.setAttribute('style', 'margin-right: 1em;');
  node.innerText = (el.match(/: ([^:]*)$/g) || [''])[0];
  return [nodeIcon, node];
};

const cssFaClass = (type) => {
  switch (type) {
    case 'unit': {
      return 'fa-house';
    }
    case 'room': {
      return 'fa-couch';
    }
    case 'bed': {
      return 'fa-bed';
    }
    default: {
      return '';
    }
  }
};

window.Guest = {
  roomBedsResult: roomBedsResult,
};
